import React from 'react'

type InfoProps = {
  info: string | React.ReactElement
}

export const Info = ({ info }: InfoProps) => (
  <span className='d-block mc-text-h8 mc-text--normal mc-mb-4'>{info}</span>
)
